import {makeReducer, match} from 'web-app/util/redux';
import {open, close, type ModalState} from 'web-app/react/modals-container/types';

import * as Actions from './actions';
import {type ActivityLink, type TrackingObject} from './types';

interface State {
    handleSelectActivity: (activity: ActivityLink) => void;
    addButtonText?: string;
    trackingFunction?: ({entryPoint, library}: TrackingObject) => void;
    institutionId?: string;
}

export type ActivitiesModalState = ModalState<State>;

export default makeReducer<ActivitiesModalState>(
    [
        match(Actions.show, (state, {payload}) => {
            return open<State>({
                handleSelectActivity: payload.handleSelectActivity,
                addButtonText: payload.addButtonText,
                trackingFunction: payload.trackingFunction,
                institutionId: payload.institutionId,
            });
        }),
        match(Actions.hide, () => {
            return close();
        }),
    ],
    close(),
);
